import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import ProjectTypeGroupWidget from '../../widgets/basicProjectInfo/projectTypeInfo/ProjectTypeGroupWidget'
import BtnEditAll from '../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { getSchemaProjectType } from '../../redux/actions/projectType'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../utils/widget'
import './styles.less'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import pathname from '../../constants/pathname'
import { ERR_MSG_404_PROJECT_ID } from '../../constants/msgText'
import ViewPreviousVersionButon from '../../components/buttons/viewPreviousVersionButon/ViewPreviousVersionButon'
import { Panel } from 'rsuite'

export default function ProjectTypeInfoView() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [schemaPrevious, setSchemaPrevious] = useState()
  const [showEditAll, setShowEditAll] = useState()
  
  const [isViewPrevious, setIsViewPrevious] = useState(false)

  const projectId = sessionStorage.getItem('projectId')
  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.goal}`,
    pathNameForward: `${pathname.proposal.projectName}`,
  }

  useEffect(() => {
    if (projectId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchemaProjectType(projectId)
      setSchema(_schema)
      setIsEditWidget({
        projectTypeInfo: _schema.forms?.projectTypeInfo?.id ? false : true,
      })
      let projectTypeInfo = _schema?.forms?.projectTypeInfo
        ? !_schema.forms.projectTypeInfo.disabled
        : true
      setShowEditAll(projectTypeInfo)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPrevious = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      if (isViewPrevious) {
        setIsViewPrevious(false)
        doneLoading()
        setIsLoading(false)
        return
      }
      if (schemaPrevious) {
        setIsViewPrevious(true)
        doneLoading()
        setIsLoading(false)
        return
      }
      
      const _schema = await getSchemaProjectType(id)
      setSchemaPrevious(_schema)
      setIsViewPrevious(true) 
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  const renderCurrentVersion = (
    <div className="top">
      {schema?.forms?.projectTypeInfo && (
        <ProjectTypeGroupWidget
          showCommandButton={!schema.forms.projectTypeInfo.disabled}
          schema={schema.forms.projectTypeInfo}
          isEdit={isEditWidget.projectTypeInfo}
          onChangeIsEdit={(_isEdit) =>
            handleOnChangeIsEdit('projectTypeInfo', _isEdit, setIsEditWidget)
          }
        />
      )}
    </div>
  )

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ViewPreviousVersionButon 
        handleGetSchemaPrevious={handleGetSchemaPrevious} 
        isViewPrevious={isViewPrevious}
        masterSubjectId={'1-1002,5-5002'}
      />

      {showEditAll && (
        <BtnEditAll
          onClickEditAll={getIsEditAll(isEditWidget)}
          routing={buttonRoute}
          setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
          editWidget={isEditWidget}
          forms={schema?.forms}
        />
      )}

      <div className="wrapper">
        <div style={!isViewPrevious ? { width: '100%' } : {}}>
          {isViewPrevious ? (
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              header={'version ปัจจุบัน'}
              style={{ maxHeight: '550px', overflowY: 'auto', width: '100%' }}
            >
              {renderCurrentVersion}
            </Panel>
          ) : (
            renderCurrentVersion
          )}
        </div>

        {isViewPrevious && schemaPrevious && (
          <>
            <div className="line" />
            <div>
              <Panel 
                collapsible 
                defaultExpanded 
                shaded 
                bordered 
                header={'version ก่อนหน้า'} 
                style={{ maxHeight: '550px', overflowY: 'auto', width: '100%', backgroundColor: '#e4e4ed' }}
              > 
                <div className="bottom">
                  {schemaPrevious?.forms?.projectTypeInfo && (
                    <ProjectTypeGroupWidget
                      showCommandButton={false}
                      schema={schemaPrevious.forms.projectTypeInfo}
                      isEdit={false}
                    />
                  )}
                </div>
              </Panel>
            </div>
            <br />
            <br />
          </>
        )}
      </div>
    </SidebarProposal>
  )
}